<!-- https://loading.io/ -->
<img class="booking-type-icon" width="25px" [src]="iconUrl" alt="" />
